import request from "@/api";

// 获取公钥
const getPublicKey = () => request.get("/auth/getPublicKey");

// 注销登录
const logout = () => request.get("/sso/user/logout");

export default { getPublicKey, logout };
